import {Box, styled} from '@mui/material';

type VideoContainerProps = {
    fillViewport?: boolean;
    height?: string;
};

export const VideoContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'fillViewport' && prop !== 'height',
})<VideoContainerProps>(({ fillViewport, height }) => ({
  width: '100%',
  height: height ?? (fillViewport ? '100vh' : '100%'),
  overflow: 'hidden',
}));